import React, { createContext, useCallback, useMemo, useState, useEffect } from "react";
import { isProdHosted } from "../utils/cfAccess";

export const AuthContext = createContext({
  isAuthed: false,
  login: () => {},
  logout: () => {},
});

// prod에선 CF Access가 보호하므로 isAuthed 기본 true 처리,
// 로컬/개발에선 기존처럼 세션 스토리지로 토큰 페이지 로그인 사용.
export default function AuthProvider({ children }) {
  const initial = () => (isProdHosted() ? true : sessionStorage.getItem("auth") === "true");
  const [isAuthed, setIsAuthed] = useState(initial);

  // 혹시 남아있을 수 있는 localStorage 흔적 제거
  useEffect(() => {
    if (localStorage.getItem("auth") === "true") localStorage.removeItem("auth");
  }, []);

  const login = useCallback(() => {
    // 개발 전용 로그인
    sessionStorage.setItem("auth", "true");
    setIsAuthed(true);
  }, []);

  const logout = useCallback(() => {
    // 개발 전용 로그아웃
    sessionStorage.removeItem("auth");
    setIsAuthed(false);
  }, []);

  const value = useMemo(() => ({ isAuthed, login, logout }), [isAuthed, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
